// Generate the test id for a field based on its name (to be used in MUI inputProps)
export default function getFieldTestId(name: string) {
    const testId = name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() + "-input";
    return { 'data-testid': testId };
}